import classes from "./PartnerProfileSummary.module.css";
import PartnerProfileItem from "../AnnouncementList/PartnerProfileItem/PartnerProfileItem";
import PartnerProfile from "../../user/partner/PartnerProfile";

type Props = {
  data: PartnerProfile;
  announcementItemView?: string;
  title?: string;
  onClick?: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  onCancel?: (id: string) => void;
  verifiedLabelVisible?: boolean;
  isEditable?: boolean;
};

export default function PartnerProfileSummary({
  data,
  announcementItemView,
  title,
  onClick,
  onEdit,
  onDelete,
  onCancel,
  verifiedLabelVisible,
  isEditable = false,
}: Props) {
  return (
    <div className={classes.container}>
      {title && <h3 className={classes.title}>{title}</h3>}
      <ul className={classes.announcementsList}>
        <PartnerProfileItem
          key={`partner-profile-summary-${data._id}`}
          data={data}
          announcementItemView={announcementItemView}
          onClick={onClick}
          onEdit={onEdit}
          onDelete={onDelete}
          onCancel={onCancel}
          isEditable={isEditable}
        />
      </ul>
    </div>
  );
}
